<script setup>
    const route = useRoute();
    const productKey = route.params.productKey;
    const product = await useProduct(productKey);

    const searchValue = useState('searchQuery');

    if (!product) {
        throw createError({ statusCode: 404, statusMessage: 'Product Not Found' });
    }

    const { logEvent } = useMetrics();

    const clearSearchValue = () => {
        searchValue.value = '';
    };

    onMounted(() => {
        logEvent('product_view', productKey, {
            product_name: product.name,
        });
    });
</script>

<template>
    <main class="relative mx-auto flex-grow overflow-auto px-4 sm:px-6 lg:px-8">
        <NuxtLink
            to="/"
            class="my-3 inline-block rounded-md p-2 text-center text-[#6B7280] transition-colors ease-in-out hover:bg-[#F3F4F6]"
        >
        <div class="flex gap-2 justify-center items-center">
            <svg
                width="15"
                height="15"
                viewBox="0 0 15 15"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                stroke="currentColor"
                stroke-width="0.7" 
            >
                <path
                    d="M6.85355 3.14645C7.04882 3.34171 7.04882 3.65829 6.85355 3.85355L3.70711 7H12.5C12.7761 7 13 7.22386 13 7.5C13 7.77614 12.7761 8 12.5 8H3.70711L6.85355 11.1464C7.04882 11.3417 7.04882 11.6583 6.85355 11.8536C6.65829 12.0488 6.34171 12.0488 6.14645 11.8536L2.14645 7.85355C1.95118 7.65829 1.95118 7.34171 2.14645 7.14645L6.14645 3.14645C6.34171 2.95118 6.65829 2.95118 6.85355 3.14645Z"
                    fill="currentColor"
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                ></path>
            </svg>
            <span class="text-sm ">Back to products</span>
        </div>
        </NuxtLink>

        <div v-if="!!product">
            <ProductItem :product="product" />

            <!-- Products -->
            <div class="my-4 border-2 bg-[#F3F4F6] p-6 rounded-lg">
                <h2 class="mb-8 text-2xl font-bold">Products in this family</h2>
                <section class="flex flex-col gap-4">
                    <article
                        v-for="p in product.products"
                        class="w-full"
                    >
                        <h3 class="mb-2 text-lg font-semibold">{{ p.name }}</h3>
                        <p class="mb-1 flex justify-between text-sm hover:bg-base-100">
                            <span>Number:</span>
                            <span class="flex-1 select-all text-right">
                                {{ p.number }}
                            </span>
                        </p>
                        <p
                            v-if="p.base"
                            class="mb-1 flex justify-between text-sm hover:bg-base-100"
                        >
                            <span>Base:</span>
                            <span class="flex-1 select-all text-right">{{ p.base }}</span>
                        </p>
                        <p
                            v-if="p.ean13"
                            class="mb-1 flex justify-between text-sm hover:bg-base-100"
                        >
                            <span>EAN13:</span>
                            <span class="flex-1 select-all text-right">
                                {{ p.ean13 }}
                            </span>
                        </p>
                        <p class="mb-1 flex justify-between text-sm hover:bg-base-100">
                            <span>Net Weight (kg):</span>
                            <span class="flex-1 select-all text-right">
                                {{ p.net_weight }}
                            </span>
                        </p>
                        <p class="mb-1 flex justify-between text-sm hover:bg-base-100">
                            <span>Size:</span>
                            <span class="flex-1 select-all text-right">
                                {{ p.size }}{{ p.unit?.toUpperCase() }}
                            </span>
                        </p>
                    </article>
                </section>
            </div>
        </div>
    </main>
</template>
